import t from "react";
const e = _ref => {
  let {
    children: o
  } = _ref;
  return t.createElement("div", {
    className: "olx-modal__bottombar"
  }, o);
};
export { e as BottomBar };